export default __webpack_public_path__ + "static/media/gls-mssii.acd4a0e2.svg";